export default function () {
	Nette.validators.AppModelEmailsValidatorEmail_validator = (elem, args, val) => {
		// regex taken from https://github.com/nette/forms/blob/master/src/assets/netteForms.js
		const emailRegex = new RegExp(
			/^("([ !#-[\]-~]|\\[ -~])+"|[-a-z0-9!#$%&'*+/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?$/i
		);
		const localPartRegex = /[a-zA-Z0-9]/;

		if (emailRegex.test(val) === false) {
			return false;
		}

		const localPart = val.split('@')[0];
		return localPartRegex.test(localPart);
	};
}
